import(/* webpackMode: "eager" */ "/home/interim/frontend/app/terms/page.tsx");
